/* Office Timing API client — Phase 5 Bundle C */
import { api } from "./api";

const BASE = "/office-timing";

const DEFAULTS = {
  startHHMM: "09:30",
  endHHMM: "18:30",
  graceMinutes: 15,
  weekendDay: 0,
};

export const officeTimingApi = {
  async get() {
    try {
      const res = await api.get(BASE);
      return { ...DEFAULTS, ...(res || {}) };
    } catch {
      return DEFAULTS;
    }
  },
  async update(patch) {
    const res = await api.patch(BASE, patch);
    return { ...DEFAULTS, ...(res || {}) };
  },
};
